export const mpsEndpoints = {
  // Auth
  providers: 'oauth2/providers',
  token: 'oauth2/token/',
  refreshToken: 'oauth2/provider/:provider/refresh_token',

  // User
  users: 'users',
  user: 'user',
  changeLang: 'users/lang',
  logout: 'users/logout',

  // Logs
  abyssLogPageVisit: 'logging/abyss/navigation',
};
